<div
  class="search"
  [class.search--collapsed]="!expanded"
  [class.search--expanded]="expanded">

    <fa-icon
      class="search__icon text-16"
      icon="search"
      (click)="handleToggleClick()"
      title="Search">
    </fa-icon>

    <input
      #searchInputField
      class="search__field"
      type="text"
      placeholder="Search for anatomy and condition models"
      [formControl]="searchField"
      (keyup.enter)="this.routeSearch(searchInputField.value)">

    <fa-icon
      *ngIf="expanded"
      class="search__icon search__icon--close text-16"
      icon="times"
      (click)="handleCloseClick()"
      title="Close">
    </fa-icon>


</div>